export default __webpack_public_path__ + "star-solid-brown-for-home.1c620f5c.svg";